import { BottomButtons, Box } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { AllowedLoginType, useApplicationClientContext } from 'src/state';
import { LoginButton } from './LoginButton';
import { RejectButton } from './RejectButton';

export type LoginButtonsProps = {
  showLoginButton?: boolean;
  showRejectButton?: boolean;
  loginType: AllowedLoginType;
  isValid: boolean;
};

export function LoginButtons({
  showLoginButton = true,
  showRejectButton = false,
  loginType,
  isValid,
}: LoginButtonsProps) {
  const [clientState] = useApplicationClientContext();
  const { isMobile } = useScreenSize();
  return (
    <>
      <Box grow="1" />
      <Box marginBottom={isMobile ? '68' : undefined} marginTop="28">
        <BottomButtons
          paddingBottom="0"
          paddingLeft="0"
          paddingRight="0"
          maxWidth="100%"
        >
          {showRejectButton && <RejectButton fullwidth={true} />}
          {showLoginButton && (
            <LoginButton
              loginType={loginType}
              isLoading={clientState.isSubmittingTwoStepLogin}
              isValid={isValid}
              fullwidth={true}
            />
          )}
        </BottomButtons>
      </Box>
    </>
  );
}
